const userDetails = {
  infoCard: {
    countApps: 'Кількість програм',
    payments: 'Платежі',
    spendings: 'Витрати',
    email: 'Електронна пошта',
    id: 'ID',
    currentPlan: 'Поточний план',
    balance: 'Баланс',
    status: 'Статус',
    active: 'Активний',
    registrationDate: 'Дата реєстрації',
    lastLogin: 'Останній вхід',
    country: 'Країна',
    refEmail: 'Реферер',
    reflinkId: 'Код рефлінку',
    externalParams: 'Зовнішні параметри',
  },
  editCard: {
    editDetail: 'Редагувати дані користувача',
    activateUser: 'Активувати користувача',
    resendEmail: 'Надіслати електронного листа повторно',
    removeUser: 'Видалити користувача',
    email: 'Електронна пошта',
    phone: 'Телефон',
    role: 'Роль',
    priceplan: 'Ціновий план',
    manager: 'Менеджер',
    refId: 'RefLink',
    isUserEuPayee: 'Користувач є одержувачем платежу з ЄС',
    save: 'Зберегти',
    userActivated: 'Користувача успішно активовано',
    userDeleted: 'Користувача успішно видалено',
    userChanged: 'Зміни до даних користувача успішно застосовано.',
  },
  paymentsTable: {
    userPayments: 'Платежі',
    showing: 'показано',
    paymentsOf: 'платежі з',
    noUserPaymentsFound: 'Платежі користувача не знайдено',
  },
  transactionTable: {
    userTransactions: 'Трансакції',
    showing: 'показано',
    transactionsOf: 'транзакції з',
    noUserTransactionsFound: 'Трансакції користувача не знайдено',
  },
  referralTable: {
    userReferrals: 'Реферали користувачів',
    showing: 'показується',
    referralsOf: 'реферали',
    noUserReferralsFound: 'Рефералів користувачів не знайдено',
    addNew: 'Додати реферал',
    addNewSuccess: 'Реферал успішно додано',
  },
  changeBalanceCard: {
    changeBalance: 'Змінити баланс користувача',
    amount: 'Сума',
    account: 'Рахунок',
    type: 'Тип',
    reason: 'Причина',
    id: 'Унікальний ідентифікатор платежу',
    paymentId: 'Ідентифікатор платежу',
    generate: 'Згенерувати',
    description: 'Опис',
    balanceChanged: 'Баланс успішно змінено',
  },
  reflinksModal: {
    reflinksList: 'Історія реферальних посилань',
    name: "Ім'я",
    code: 'Код',
    created: 'Створено',
  },
  externalModal: {
    externalParams: 'Зовнішні параметри',
    value: 'Значення',
  },
  tableDropdown: {
    exportUserPayments: 'Експорт'
  },
  messagesTable: {
    userMessages: 'Повідомлення',
    showing: 'Показ',
    recordes: 'записи',
    noUserMessagesFound: 'Повідомлень користувача не знайдено',
  },
};

export default userDetails;
